module.exports = __webpack_public_path__ + "img/diaohua4.78ff1b9e.jpg";